import { useEffect } from 'react';

import { env } from '@/lib/env';

/**
 * Sets `document.title` to «<page> · <clinic> — بوکورا».
 *
 * The clinic name is in the title on purpose: staff who work at two clinics
 * keep both panels open in adjacent tabs, and the tab strip is the only place
 * they can tell them apart at a glance.
 */
export function useDocumentTitle(page: string | undefined, clinicName?: string | null): void {
  useEffect(() => {
    const parts = [page, clinicName].filter((part): part is string => Boolean(part));
    document.title = parts.length > 0 ? `${parts.join(' · ')} — ${env.appName}` : env.appName;
  }, [page, clinicName]);
}
